module.exports = {
  title: '爱车专区-专区分类设置',
  route: {
    path: '/content-manage',
    children: {
      path: 'love-car-new-classify',
    },
  },
};
